import getYear from '@teetsh/app/src/utils/time/getYear';
import getMonth from '@teetsh/app/src/utils/time/getMonth';
import getDate from '@teetsh/app/src/utils/time/getDate';
import setMonth from '@teetsh/app/src/utils/time/setMonth';
import setDate from '@teetsh/app/src/utils/time/setDate';
import setYear from '@teetsh/app/src/utils/time/setYear';

export default function setDateAtAnotherDate(
  dateToModify: Date,
  date: Date,
): Date {
  const year = getYear(date);
  const month = getMonth(date);
  const day = getDate(date);
  return setDate(setMonth(setYear(dateToModify, year), month), day);
}
